import { ActiveGameStore as BaseStore } from '@bn-games/history-core';
import { HISTORY_SCHEMA_VERSION, type ActiveSession } from './types.js';

// Per-app singleton wrapping @bn-games/history-core's generic store with
// chess's storage key, schema version and shape predicate.
export const ActiveGameStore = new BaseStore<ActiveSession>({
  storageKey: 'chess-active-game',
  schemaVersion: HISTORY_SCHEMA_VERSION,
  isValid: (parsed) =>
    parsed['mode'] === 'online' && typeof parsed['roomCode'] === 'string' && typeof parsed['id'] === 'string' &&
    Array.isArray(parsed['moves']) && Array.isArray(parsed['clocks']),
});
